var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContractsSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 124,
    viewBox: "0 0 248 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0H224C237.255 0 248 10.7452 248 24V100C248 113.255 237.255 124 224 124H24C10.7452 124 0 113.255 0 100V24Z",
    fill: "#5C6FCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.302 84.5567C141.302 86.5363 139.697 88.1411 137.717 88.1411H111.432C109.452 88.1411 107.847 86.5363 107.847 84.5567V58.271C107.847 56.2914 109.452 54.6866 111.432 54.6866H137.717C139.697 54.6866 141.302 56.2914 141.302 58.271V84.5567Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.973 86.4111C102.973 87.2603 102.285 87.9487 101.436 87.9487H90.1599C89.3107 87.9487 88.6223 87.2603 88.6223 86.4111V75.1355C88.6223 74.2863 89.3107 73.5979 90.1599 73.5979H101.436C102.285 73.5979 102.973 74.2863 102.973 75.1355V86.4111Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.105 67.6954C103.105 68.5623 102.403 69.265 101.536 69.265H90.0253C89.1584 69.265 88.4556 68.5623 88.4556 67.6954V56.1848C88.4556 55.3179 89.1584 54.6152 90.0253 54.6152H101.536C102.403 54.6152 103.105 55.3179 103.105 56.1848V67.6954ZM121.941 48.8599C121.941 49.7268 121.238 50.4295 120.371 50.4295H108.861C107.994 50.4295 107.291 49.7268 107.291 48.8599V37.3494C107.291 36.4825 107.994 35.7797 108.861 35.7797H120.371C121.238 35.7797 121.941 36.4825 121.941 37.3494V48.8599Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M101.536 50.4294C102.403 50.4294 103.105 49.7267 103.105 48.8598V37.3492C103.105 36.4824 102.403 35.7796 101.536 35.7796H90.0253C89.1584 35.7796 88.4557 36.4824 88.4557 37.3492V48.8598C88.4557 49.7267 89.1584 50.4294 90.0253 50.4294H101.536Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.462 50.429C127.595 50.429 126.893 49.7263 126.893 48.8594V37.3489C126.893 36.482 127.595 35.7792 128.462 35.7792H139.973C140.84 35.7792 141.542 36.482 141.542 37.3489V48.8594C141.542 49.7263 140.84 50.429 139.973 50.429H128.462ZM147.298 69.2645C146.431 69.2645 145.728 68.5618 145.728 67.6949V56.1843C145.728 55.3175 146.431 54.6147 147.298 54.6147H158.808C159.675 54.6147 160.378 55.3175 160.378 56.1843V67.6949C160.378 68.5618 159.675 69.2645 158.808 69.2645H147.298ZM145.728 48.8594C145.728 49.7263 146.431 50.429 147.298 50.429H158.808C159.675 50.429 160.378 49.7263 160.378 48.8594V37.3489C160.378 36.482 159.675 35.7792 158.808 35.7792H147.298C146.431 35.7792 145.728 36.482 145.728 37.3489V48.8594Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.234 88.2477C146.367 88.2477 145.664 87.5449 145.664 86.6781V75.1675C145.664 74.3006 146.367 73.5979 147.234 73.5979H158.744C159.611 73.5979 160.314 74.3006 160.314 75.1675V86.6781C160.314 87.5449 159.611 88.2477 158.744 88.2477H147.234Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractsSmall);
export default __webpack_public_path__ + "static/media/contracts-small.38befb02.svg";
export { ForwardRef as ReactComponent };